import { combineReducers } from 'redux';
import ui from '@/redux/reducers/uiReducer.js';
import pieve from '@/redux/reducers/pieveReducer.js';
import onboarding from '@/redux/reducers/onboardingReducer.js';
import settings from '@/redux/reducers/settingsReducer.js';
import user from '@/redux/reducers/userReducer.js';

const rootReducer = (routerReducer) => {
  return combineReducers({
    router: routerReducer,
    ui,
    user,
    pieve,
    onboarding,
    settings
  });
};

export default rootReducer;
